import { gql } from "@apollo/client";

export const CREATE_CASE_SCHEDULE = gql`
  mutation CreateCaseSchedule($data: CaseScheduleInputData!) {
    createCaseSchedule(data: $data)
  }
`;
